import { useMutation } from 'react-query';

import { shareProject } from 'shared/api/projects/http';

const useMutateShareProject = (options = undefined) => useMutation(({ id, share }) => shareProject(id, share), options);

export default useMutateShareProject;
